export function createDeploymentLink(url, slug) {
  return url
    ? `${url.startsWith('localhost') ? 'http' : 'https'}://${slug}.vercel.app`
    : '';
}
